import { useTranslation } from "react-i18next";
import Dialog from "components/shared/Dialog";
import SimpleTable from "components/shared/tables/SimpleTable";
import Button from "components/shared/Button";
import { cn } from "lib/utils";
import { useColumns } from "./columns";
import type { ResultDialogProps, ShiftResult } from "./types";

function ResultDialog({ isOpen, close, values }: ResultDialogProps) {
    const { t } = useTranslation();
    const columns = useColumns();

    return (
        <Dialog
            title={t("summary")}
            open={isOpen}
            close={close}
            size="4xl"
        >
            <SimpleTable<ShiftResult>
                className={cn(
                    "tw-whitespace-nowrap",
                    // failed rows are flagged by the marker class on their status badge
                    "[&_tr:has(.shift-result-failed)]:tw-bg-rose-50",
                    "[&_tr:has(.shift-result-failed):hover]:tw-bg-rose-100"
                )}
                data={values || []}
                columns={columns}
                getRowKey={(row, index) => row?.shiftId ?? row?.userId ?? row?.request?.id ?? index}
            />
            <div className="tw-flex tw-justify-end">
                <Button type="button" onClick={close}>
                    {t("close")}
                </Button>
            </div>
        </Dialog>
    );
}

export default ResultDialog;
